module.exports = __webpack_public_path__ + "static/media/background-auth-modal.833c1073.jpg";